import type { DocumentReference } from "@medplum/fhirtypes";
import { DOCUMENT_REFERENCE_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useDocumentReferenceSubscription = createSubscriptionHook<DocumentReference>(
  "DocumentReference",
  DOCUMENT_REFERENCE_COLLECTION_NAME,
);
